import * as fmt from '../../util/fmt_utils'

// returns either a formatted date string, or empty string
export function ensureValidEndDate(endDate, hasDefaultDate, startAt) {
    let endDateWithYear = dateWithYear(endDate)
    // a valid date is at least 8 characters long
    const invalidDate = endDateWithYear.length  < 8 || new Date(endDateWithYear).toString() === "Invalid Date"

    // if the date is invalid, attempt to set the date to now if more conditions are met
    if (invalidDate) {
        // if there is an end date and its invalid
        // OR
        // the end date is empty BUT the field requires a date
        // then the end date defaults to now
        if (endDateWithYear || hasDefaultDate) {
            endDateWithYear = fmt.numDateShort(new Date())
        }
    }

    // if start at is empty, then we have nothing to compare the endDate to,
    // short circuit to empty string
    if (!startAt) {
        return ''
    }

    // if given date is less start at return start at
    // so you can't set end at in the past
    if (new Date(endDateWithYear).getTime() < startAt && !hasDefaultDate) {
        endDateWithYear = fmt.numDateShort(new Date(startAt))
    }

    return endDateWithYear
}

export function isEndAtBeforeStartAt(endDate, startAt) {
    if (!endDate || !startAt) {
        return false
    }

    const endDateMs = new Date(fmt.numDateShort(endDate)).getTime()
    const startDateMs = new Date(fmt.numDateShort(startAt)).getTime()

    return endDateMs < startDateMs
}

export function dateWithYear(input) {
    const splitItems = input.split('/').filter(x => x !== "")

    return splitItems.length === 1 ? `${input}/1/${new Date().getFullYear()}`
        : splitItems.length === 2 ? `${input}/${new Date().getFullYear()}` : input
}


// WEBPACK FOOTER //
// ./src/common/components/date_input.js